<template>
  <CRow>
    <CCol col="12" xl="12">
      <transition name="slide">
      <CCard>
        <CCardBody>
            <div class="row justify-content-end align-items-center">
              <form class="form-inline">
                <div class="mr-2">
                  <CButton v-if="permissions.orders.add" color="success" @click="createOrder()">
                    <CIcon :content="$options.addIcon" /> {{ $t('button.create') }} {{ $t('orders.label') }}
                  </CButton>
                </div>
                <div class="form-group">
                  <label for="from-date">{{ $t('from') }}:</label>
                  <input type="date" id="from-date" v-model="from" class="form-control mx-sm-3">
                </div>
                <div class="form-group">
                  <label for="to-date">{{ $t('to') }}:</label>
                  <input type="date" id="to-date" v-model="to" class="form-control mx-sm-3">
                </div>
                <CButton color="primary" @click="getOrders">
                  <CIcon :content="$options.filterIcon" /> {{ $t('filter') }}
                </CButton>
              </form>
            </div>
            <CDataTable
              :items="filteredItems"
              :fields="fields"
              :items-per-page="perPage"
              :itemsPerPageSelect="itemsPerPage"
              :table-filter-value.sync="search"
              :loading="loading"
              tableFilter
              ref="dataTable"
              addTableClasses="d-print-table table-dropdown-fix"
              hover
              sorter
              pagination
            >
              <template #payment_type="{item}">
                <td>
                  <CBadge :color="item.payment_class">{{item.payment_type}}</CBadge>
                </td>
              </template>
              <template #pay="{item}">
                <td>
                  <CBadge :color="item.payment_class">{{item.pay}}</CBadge>
                </td>
              </template>
              <template #amount="{item}">
                <td>
                  ${{item.amount}}
                </td>
              </template>
              <template #attended_by="{item}">
                <td>
                  {{item.user}}
                </td>
              </template>
              <template #options="{item}">
                <td>
                  <div class="dropdown">
                    <button class="btn btn-secondary dropdown-toggle" @click="openOptions" type="button" data-toggle="dropdown">
                      {{ $t('button.options') }}
                    </button>
                    <div class="dropdown-menu">
                      <button v-if="permissions.orders.read" class="dropdown-item" type="button" @click="showOrder(item.id)">{{ $t('button.details') }}</button>
                      <button v-if="permissions.orders.edit" class="dropdown-item" type="button" @click="editOrder(item.id)">{{ $t('button.edit') }}</button>
                      <button v-if="permissions.orders.delete" class="dropdown-item" type="button" @click="deleteOrder(item.id)">{{ $t('button.delete') }}</button>
                    </div>
                  </div>
                </td>
              </template>
            </CDataTable>
        </CCardBody>  
      </CCard>
      </transition>
    </CCol>
  </CRow>
</template>

<script>
import { mapState } from 'vuex';
import axios from 'axios';
import listMixin from '../../mixins/list';
import localeMixin from '../../mixins/locale'; // Order matters, mixin first then i18n.
import i18n from "../../i18n";
import { cilFilter, cilPlus } from '@coreui/icons';

export default {
  name: 'Orders',
  mixins: [listMixin, localeMixin],
  addIcon: cilPlus,
  filterIcon: cilFilter,
  data() {
    return {
      items: [],
      fields: [
        { key: 'driver', label: i18n.t('fields.driver') },
        { key: 'name', label: i18n.t('fields.name') }, 
        { key: 'address', label: i18n.t('fields.address')},
        { key: 'address2', label: i18n.t('fields.address2')},
        { key: 'city', label: i18n.t('fields.city')},
        { key: 'phone', label: i18n.t('fields.phone')},
        { key: 'phone2', label: i18n.t('fields.phone2')},
        { key: 'quantity', label: i18n.t('fields.quantity') },
        { key: 'payment_type', label: i18n.t('fields.payment_type') }, 
        { key: 'pay', label: i18n.t('pay') }, 
        { key: 'amount', label: i18n.t('fields.amount') }, 
        { key: 'comment', label: i18n.t('fields.comment') }, 
        { key: 'delivery_types', label: i18n.t('fields.delivery_type') }, 
        { key: 'order_date', label: i18n.t('fields.order_date') }, 
        { key: 'attended_by', label: i18n.t('fields.attended_by') }, 
        {
          key: 'options',
          label: i18n.t('button.options'),
          sorter: false,
          filter: false
        }
      ],
      you: null,
      from: '',
      to: '',
      tableFilter: {
        label: i18n.t('search'),
        placeholder: i18n.t('clients.search_placeholder'),
        lazy: false,
        external: true
      },
      sorterValue: {
        column: 'order_date',
        desc: 'true'
      }
    }
  },
  computed: {
    ...mapState({
      permissions: state => state.permissions,
    }),
    filteredItems() {
        return this.items.filter(i => {
            return i.name.toLowerCase().includes(this.search.toLowerCase()) || 
                ((!i.driver) ? '' : i.driver).toLowerCase().includes(this.search.toLowerCase()) ||
                ((!i.address) ? '' : i.address).toLowerCase().includes(this.search.toLowerCase()) ||
                ((!i.address2) ? '' : i.address2).toLowerCase().includes(this.search.toLowerCase()) ||
                ((!i.city) ? '' : i.city).toLowerCase().includes(this.search.toLowerCase()) ||
                ((!i.phone) ? '' : i.phone).includes(this.search.toLowerCase()) ||
                ((!i.phone2) ? '' : i.phone2).includes(this.search.toLowerCase())
            });
    }
},
  mounted() {
    this.getOrders();
  },
  methods: {
    showOrder (id) {
      this.$router.push({ name: 'Order', params: {id} });
    },
    editOrder (id) {
      this.$router.push({ name: 'EditOrder', params: {id} });
    },
    deleteOrder (id) {
      this.$swal({
        title: i18n.t('orders.modal.delete_label'),
        html: i18n.t('orders.modal.delete_body'),
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: i18n.t('button.accept')
      }).then(result => {
        if (result.value) {
          // do delete request
          axios.delete('/api/orders/'+ id + '?token=' + localStorage.getItem("api_token"))
          .then(response => {
            this.$swal(
              i18n.t('orders.modal.deleted_label'),
              i18n.t('orders.modal.deleted_body'),
              'success'
              );
              this.getOrders();
          });
        }
      });
    },
    createOrder () {
      this.$router.push({ name: 'CreateOrder' });
    },
    getOrders () {
        let self = this;

        this.loading = true;
        let url = '/api/orders?token=' + localStorage.getItem("api_token");

        if (this.from !== '') {
            url = url + '&from=' + this.from;
        }

        if (this.to !== '') {
            url = url + '&to=' + this.to;
        }

        axios.get(url)
            .then(response => {
                this.loading = false;
                this.items = response.data;
                self.search = "";
            }).catch(error => {
                this.loading = false;
                console.log(error);
                this.$router.push({ path: '/login' });
            });
    }
  }
}
</script>
